import type { JsonObject } from '@hexia/survey-client/core';

/** Apply shopper receipt rules to the in-memory definition, never the stored form. */
export const withReceiptAmountConstraints = (form: JsonObject, errorMessage: string): JsonObject => {
  const visit = (node: JsonObject): JsonObject => {
    const next = { ...node };
    for (const property of ['pages', 'elements']) {
      if (Array.isArray(node[property])) next[property] = node[property].map((child) => child && typeof child === 'object' && !Array.isArray(child) ? visit(child) : child);
    }
    if (node.type === 'text' && String(node.hexaTaxonomy) === '6') {
      next.inputType = 'number';
      next.min = Math.max(0, typeof node.min === 'number' ? node.min : 0);
      next.maskType = ['numeric', 'currency'].includes(String(node.maskType)) ? node.maskType : 'numeric';
      const mask = node.maskSettings && typeof node.maskSettings === 'object' && !Array.isArray(node.maskSettings) ? node.maskSettings : {};
      const configuredPrecision = typeof mask.precision === 'number' && Number.isInteger(mask.precision) && mask.precision >= 0 && mask.precision <= 15
        ? mask.precision
        : 2;
      next.maskSettings = { ...mask, precision: configuredPrecision, allowNegativeValues: false };
      next.numberErrorText = errorMessage;
    }
    return next;
  };
  return visit(form);
};
